'use client'

import { useState } from 'react'

/**
 * Brand logo for the brand index. Renders the pre-fetched static PNG from
 * public/brand-logos/{slug}.png. Falls back to a 2-letter initials badge
 * if the image is missing (e.g., Google's favicon service didn't have the
 * domain — happens for ~1 in 50 brands).
 */
export default function BrandLogo({
  slug,
  brand,
  size = 32,
}: {
  slug: string
  brand: string
  size?: number
}) {
  const [errored, setErrored] = useState(false)

  if (errored) {
    const initials = brand
      .split(/\s+/)
      .slice(0, 2)
      .map(s => s[0])
      .join('')
      .toUpperCase()
    return (
      <div
        className='flex items-center justify-center rounded font-bold text-foreground/70 bg-muted flex-shrink-0'
        style={{ width: size, height: size, fontSize: size * 0.4 }}
        aria-label={`${brand} logo`}
      >
        {initials}
      </div>
    )
  }

  return (
    <img
      src={`/brand-logos/${slug}.png`}
      alt={`${brand} logo`}
      width={size}
      height={size}
      className='rounded flex-shrink-0 object-contain bg-white p-0.5'
      onError={() => setErrored(true)}
      loading='lazy'
    />
  )
}
